import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { ToggleComponent } from './toggle.component';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ToggleComponent],
  imports: [CommonModule, FlexLayoutModule, TranslocoModule, FormsModule, ToggleSwitch],
  exports: [ToggleComponent],
})
export class ToggleModule {}
